/** A stalled transfer is uncertain, not proof that the provider received no bytes. */
export function uploadDeadline(signal?: AbortSignal, stallMs?: number) {
  const controller = new AbortController();
  let lastLoaded = 0;
  let timer: ReturnType<typeof setTimeout> | undefined;
  let stalled = false;
  const cancel = () => controller.abort();
  signal?.addEventListener('abort', cancel, { once: true });
  if (signal?.aborted) cancel();
  const arm = () => {
    if (!stallMs) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      stalled = true;
      cancel();
    }, stallMs);
  };
  arm();
  return {
    signal: controller.signal,
    progress(loaded: number) {
      if (loaded > lastLoaded) {
        lastLoaded = loaded;
        arm();
      }
    },
    failure(error: unknown) {
      return stalled
        ? Object.assign(
            new Error(
              'Upload stalled. Check your connection and retry this file; its upload identity is retained.',
            ),
            { code: 'PACKING_UPLOAD_STALLED' },
          )
        : error;
    },
    dispose() {
      clearTimeout(timer);
      signal?.removeEventListener('abort', cancel);
    },
  };
}
